import React, { useState } from "react";
import { Logo } from "./Logo";
import { EyeIcon } from "@heroicons/react/solid";
import { LibraryIcon } from "@heroicons/react/solid";
import { BookOpenIcon } from "@heroicons/react/solid";
import { MenuIcon } from "@heroicons/react/outline";
import { NavLink } from "react-router-dom";

export const AppMenu = (props) => {
  const menuSelectionRender = () => {
    setMenuOpen(false);
    props.setDrawerOpen(true);
  };

  const mapSelectionRender = () => {
    setMenuOpen(false);
    props.setDrawerOpen(false);
  };
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div>
      <NavLink
        to="/"
        onClick={() => mapSelectionRender()}
        className="w-12 h-12 absolute top-2 left-4 z-50  flex justify-center"
      >
        <Logo className="w-full h-full" />
      </NavLink>
      <div
        className="w-12 h-12 absolute top-2 left-20 z-50  flex justify-center"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <MenuIcon className="w-full h-full" />
      </div>
      <div
        className={` transform transition absolute top-16 left-0 z-30 bg-white rounded-r-md shadow-md ${
          menuOpen ? "" : "-translate-x-full"
        }`}
      >
        <ul className="p-4 w-48 divide-y-2">
          <NavLink
            onClick={() => mapSelectionRender()}
            to="/"
            className="flex items-center py-2 opacity-60"
            activeClassName="opacity-100 flex items-center"
          >
            <li className="flex">
              <EyeIcon className="w-6 h-6 mr-2" />
              <span>Map</span>
            </li>
          </NavLink>
          <NavLink
            onClick={() => menuSelectionRender()}
            to="/allvenues"
            className="flex items-center py-2 opacity-60"
            activeClassName="opacity-100 flex items-center"
          >
            <li className="flex">
              <LibraryIcon className="w-6 h-6 mr-2" />
              <span>Venues</span>
            </li>
          </NavLink>
          <NavLink
            onClick={() => menuSelectionRender()}
            to="/events"
            className="flex items-center py-2 opacity-60"
            activeClassName="opacity-100 flex items-center"
          >
            <li className="flex">
              <EyeIcon className="w-6 h-6 mr-2" />
              <span>Events</span>
            </li>
          </NavLink>

          <a
            href="https://www.arttasting.com/"
            target="_blank"
            rel="noreferrer nofollow"
            className="flex items-center py-2 opacity-60"
          >
            <li className="flex">
              <BookOpenIcon className="w-6 h-6 mr-2" /> <span>About</span>
            </li>
          </a>
          <a
            href="https://artt-portal.vercel.app/"
            target="_blank"
            rel="noreferrer nofollow"
            className="flex items-center py-2 opacity-60"
          >
            <li className="flex">
              <LibraryIcon className="w-6 h-6 mr-2" /> <span>Add Gallery</span>
            </li>
          </a>
        </ul>
      </div>
    </div>
  );
};
